module.exports = __webpack_public_path__ + "img/akatex.9f831634.jpg";